module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00051-fs8.ca22f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00051-fs8.png
// module id = 204
// module chunks = 0